// Used to store getSteps functionality in a variable
export const steps = [
    "Personal info",
    "Official info",
    "Bank Details",
    "PF & ESI Details",
    "Tax Details",
  ]; 

//Dropdowns
export const resourceOptions = {
    salutation: [
      { value: "Mr.", label: "Mr." },
      { value: "Ms.", label: "Ms." },
      { value: "Mrs.", label: "Mrs." },
      { value: "Dr.", label: "Dr." },
    ],
    gender: [
      { value: "Male", label: "Male" },
      { value: "Female", label: "Female" },
      { value: "Other", label: "Other" },
    ],
    martialstatus: [
      { value: "Single", label: "Single" },
      { value: "Married", label: "Married" },
      { value: "Divorced", label: "Divorced" },
      { value: "Separated", label: "Separated" },
      { value: "Widowed", label: "Widowed" },
    ],
    shifts: [
      { value: "Regular", label: "Regular" },
      { value: "Night", label: "Night" },
    ],
    employeeType: [
      { value: "Employee", label: "Employee" },
      { value: "Intern", label: "Intern" },
    ],
    reportManager: [],
    department: [],
    designation: [],
  };

  //Employee Type
export const typedata = [
    { value: "Employee", label: "Employee" },
    { value: "Internship", label: "Internship" },
    {value:"Consultant",label:"Consultant"},
  ];